import { WorkupItem } from "fe-common/graphql";
import * as React from "react";
import { styled } from "@mui/material";
//region [[ Styles ]]
const IndexedList = styled("ul")({
  padding: 0,
  listStyleType: "none",
  listStyle: "none",
  marginTop: 4,
  "& li": {
    paddingLeft: 0,
    display: "flex",
    gap: 6,
    alignItems: "start",
  },
  "& .itemtext:first-letter": {
    textTransform: "capitalize",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]
export interface GroupedWorkupListProps {
  workupList: WorkupItem[];
}
export const GroupedWorkupList = ({ workupList }: GroupedWorkupListProps) => {
  const grouped = workupList.reduce((list, item) => {
    list[item.category] = list[item.category] || [];
    list[item.category].push(item);
    return list;
  }, {});

  return (
    <>
      {Object.keys(grouped).map((key) => (
        <div key={key}>
          <strong style={{ textTransform: "capitalize" }}>{key}:</strong>
          <IndexedList>
            {grouped[key]?.length > 1 ? (
              grouped[key]?.map((item, index) => (
                <li key={key + index}>
                  <div className="itemnum">{index + 1}.</div>
                  <div className="itemtext">{item.title}</div>
                </li>
              ))
            ) : (
              <div className="itemtext">{grouped[key][0].title}</div>
            )}
          </IndexedList>
        </div>
      ))}
    </>
  );
};
